
$(document).ready(function () {

    $(".dropdown-btn").on('click',function(){
        $($(this).attr('dropdownid')).toggle();
    });

    $(".version_btn").on('click',function(){
        $($(this).attr('dropdownid')).toggle();
        $('.version_table').css("display", "none");
        $($(this).attr('versionid')).toggle();

        $('.version_btn').each(function() {
            $(this).text( $(this).attr('version') );
        });
        $(this).text($(this).attr('version')+' - Current');
    });

    $('.custom-file-input').on('change',function(){
        //get the file name
        var fileName = $(this).val();
        //replace the "Choose a file" label
        $(this).next('.custom-file-label').html(fileName);
    })

});